import React from 'react'
import { get } from 'lodash'
import { Redirect } from 'react-router-dom'

import config from 'config'
import { Leader as LeaderPage } from 'containers/pages/register'
import * as Leader from 'containers/forms/leader'

const urlPrefix = `${config.publicPath}/register/leader`

export default [
  {
    path: `${urlPrefix}`,
    component: props => (
      <LeaderPage logout {...props} />
    ),
    routes: [
      {
        path: `${urlPrefix}`,
        exact: true,
        component: props => (
          <Redirect to={{
            pathname: `${config.publicPath}/register/leader/unit-details`,
            search: get(props, 'location.search')
          }}
          />
        ),
        routes: []
      },
      {
        path: `${urlPrefix}/unit-details`,
        exact: true,
        component: props => (
          <Leader.UnitDetails {...props} />
        ),
        activeId: 1,
        routes: []
      },
      {
        path: `${urlPrefix}/contact-details`,
        exact: true,
        component: props => (
          <Leader.ContactDetails {...props} />
        ),
        activeId: 2,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/leader-details`,
        exact: true,
        component: props => (
          <Leader.LeaderDetails {...props} />
        ),
        activeId: 3,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/account`,
        exact: true,
        component: props => (
          <Leader.Account {...props} />
        ),
        activeId: 4,
        hideLocaleSwitcher: true,
        routes: []
      },
      {
        path: `${urlPrefix}/success`,
        exact: true,
        component: props => (
          <Leader.Success {...props} />
        ),
        activeId: 5,
        hideLocaleSwitcher: true,
        routes: []
      }
    ]
  }
]
